<template>
  <div
    class="tooltip-triangle text-static-white absolute -top-[46px] z-10 w-fit whitespace-nowrap rounded-md px-1.5 py-1 text-xs font-medium lowercase"
    :class="[
      {
        'bg-background-positive-primary after:border-t-background-positive-primary':
          isMinPrice,
      },
      {
        'bg-situational-grey after:border-t-situational-grey': isUnknownPrice,
      },
      {
        'bg-background-info-primary after:border-t-background-info-primary':
          !isMinPrice && !isUnknownPrice,
      },
    ]"
  >
    {{ tooltipText }}
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { prettyPrice } from '@aviata/text-fns';

  const props = defineProps<{
    price?: string;
    isUnknownPrice: boolean;
    isMinPrice: boolean;
  }>();

  const { t } = useI18n();

  const tooltipText = computed(() =>
    props.isUnknownPrice
      ? t('search.nearestSearchesRoundTrip.priceUnknown')
      : t('general.price.startFrom', { price: prettyPrice(props.price ?? '') }),
  );
</script>

<style scoped>
  .tooltip-triangle:after {
    @apply absolute left-[calc(50%-8px)] top-[25px] h-0 w-0 border-x-8 border-t-[12px] border-x-transparent;
    content: '';
  }
</style>
